import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-3 col-lg-3 col-md-6 col-sm-6" }
const _hoisted_3 = { class: "col-xxl-3 col-lg-3 col-md-6 col-sm-6" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header border-0 pt-6" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_8 = {
  href: "#",
  class: "btn btn-success me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_sub_add_al"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus fs-4 me-2" }, null, -1)
const _hoisted_10 = {
  href: "#",
  class: "btn btn-danger me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_sub_deduct_al"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus fs-4 me-2" }, null, -1)
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_14 = {
  key: 1,
  class: "badge badge-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsWidget5 = _resolveComponent("StatisticsWidget5")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_AddAlTransaction = _resolveComponent("AddAlTransaction")!
  const _component_DeductAlTransaction = _resolveComponent("DeductAlTransaction")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_StatisticsWidget5, {
          "widget-classes": "card-xl-stretch mb-8",
          "svg-icon": "/media/icons/duotune/finance/fin006.svg",
          color: "info",
          "icon-color": "white",
          title: _ctx.$n(Number(_ctx.subAgent.al_balance), 'currency'),
          description: _ctx.$t('DashboardSummary.SubAgentCurrentAl')
        }, null, 8, ["title", "description"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_StatisticsWidget5, {
          "widget-classes": "card-xl-stretch mb-8",
          "svg-icon": "/media/icons/duotune/finance/fin001.svg",
          color: "success",
          "icon-color": "white",
          title: _ctx.$n(_ctx.totalDeposit, 'currency'),
          description: _ctx.$t('DashboardSummary.TotalDeposit')
        }, null, 8, ["title", "description"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.$t("Deposit.ADD")), 1)
            ]),
            _createElementVNode("a", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(_toDisplayString(_ctx.$t("Deposit.DEDUCT")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true
        }, {
          "cell-memo": _withCtx(({ row: deposit }) => [
            (deposit.memo === 'ADD')
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("Deposit." + deposit.memo)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("Deposit." + deposit.memo)), 1))
          ]),
          _: 1
        }, 8, ["table-data", "table-header"])
      ])
    ]),
    _createVNode(_component_AddAlTransaction, {
      subAgentId: _ctx.$route.params.subagentid,
      onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getAlDeposits(_ctx.$route.params.subagentid)))
    }, null, 8, ["subAgentId"]),
    _createVNode(_component_DeductAlTransaction, {
      subAgentId: _ctx.$route.params.subagentid,
      onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getAlDeposits(_ctx.$route.params.subagentid)))
    }, null, 8, ["subAgentId"])
  ], 64))
}